import withAuthentication from 'modules/authentication/withAuthentication'
import LayoutRoute from './LayoutRoute'

export default withAuthentication(LayoutRoute)
